export default __webpack_public_path__ + "static/media/groundPart8.638e4028.webp";